import { Link } from "gatsby"
import { Img } from "../../../../layout/Img"

function CardItem({ blog }) {
  return (
    <div className="shadow-lg">
      <Link to={`/${blog.uri}`}>
        <div className="overflow-hidden rounded-lg">
          {/* aspect-w-5 aspect-h-3 */}
          <div className="relative ">
            <Img
              image={blog.coverPicture[0]}
              className="h-60"
            />
            {/* <GatsbyImage className= image={image} alt={blog.resourceCategory[0].title} /> */}
          </div>
          <div className="p-6 mt-2 aspect-h-3">
            <span className="px-2 py-1 text-xs uppercase border-2 rounded-full 2xl:text-sm text-secondary border-highlightColor">
              {blog.resourceCategory[0].title}
            </span>
          </div>
          <header className="flex flex-col px-6 leading-tight aspect-h-6">
            <h3 className="mb-10 text-xl font-semibold md:text-lg text-secondary 2xl:text-2xl">
              {blog.title}
            </h3>
          </header>
        </div>
      </Link>
    </div>
  )
}

export default CardItem
